import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import IconNoData from '@/components/base/IconNoData'
import useTrans from '@/hooks/useTrans'

const View = () => {
  const trans = useTrans()

  return (
    <Stack data-testid="top-coins-empty-row" className="text-center">
      <IconNoData />
      <Typography className="text-sm mt-2 text-[#B0B2BE]">{trans.no_data}</Typography>
    </Stack>
  )
}

export default View
